export default __webpack_public_path__ + "static/media/infinity.a1250502.svg";